import { render, staticRenderFns } from "./OrdemServicoForm2.vue?vue&type=template&id=568528d8&scoped=true&"
import script from "./OrdemServicoForm2.vue?vue&type=script&lang=js&"
export * from "./OrdemServicoForm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568528d8",
  null
  
)

export default component.exports